import { render, staticRenderFns } from "./comTerm14.vue?vue&type=template&id=5136dc12&scoped=true&"
import script from "./comTerm14.vue?vue&type=script&lang=js&"
export * from "./comTerm14.vue?vue&type=script&lang=js&"
import style0 from "./comTerm14.vue?vue&type=style&index=0&id=5136dc12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5136dc12",
  null
  
)

export default component.exports